import styled, { css } from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';
import { getFontScale } from 'themes/mixins/getFontScale';

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Input = styled.input<{ $hasError?: boolean }>`
  display: block;

  width: 3rem;
  padding: 0.1rem 0.2rem;

  text-align: center;

  color: ${pickColor('black')};
  border: 0.1rem solid ${pickColor('borderLight')};
  background-color: ${pickColor('white')};

  ${getFontScale('xs')};

  &::placeholder {
    color: ${pickColor('grayDarkSecondary')};
  }

  &:focus::placeholder {
    color: transparent;
  }

  /* Remove browser spin buttons */
  -moz-appearance: textfield;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &:disabled {
    background-color: ${pickColor('gray')};
    border-color: ${pickColor('borderDisabled')};
    cursor: not-allowed;
  }

  &:focus {
    outline: none;
    border-color: ${pickColor('colmarBlue')};
  }

  /* A quantity that failed to save and was reverted (order grid) */
  ${({ $hasError }) =>
    $hasError &&
    css`
      &,
      &:focus {
        border-color: ${pickColor('red')};
        box-shadow: 0 0 0 0.1rem ${pickColor('red')};
      }
    `}
`;

export { Input, Wrapper };
